import React from "react";
import {  useSelector } from "react-redux";
import './Alert.css';

const Alert = () => {
  const alertConfig = useSelector(state => state.config.alert);

  return(
    <a className={"alert-container" + (alertConfig.url!==""?" with-url":"")} 
      style={{backgroundColor:alertConfig.bgColor,color:alertConfig.textColor}}
      href={alertConfig.url}> 
      <div className="label">
        { alertConfig.label }
      </div>
    </a>
  )
};

export default Alert;